// extracted by mini-css-extract-plugin
export default {"sectionWhatsapp":"WhatsappSection_sectionWhatsapp__VdKpO","boton":"WhatsappSection_boton__h4gVX"};